export const LoginSection = ({
    user,
    handleGoogleLogin,
    handleLogout,
    backupToCloud,
    fetchFromCloud,
    syncMessage,
}) => {
    return (
        <section>
        <div className="card p-6 mb-4 text-left bg-slate-50 border border-slate-200 rounded-2xl shadow-sm">
          <div className="flex items-center gap-1.5 mb-4">
            <span className="w-1 h-3.5 bg-indigo-600 rounded-full"></span>
            <h3 className="font-extrabold text-slate-800 text-xs tracking-wider uppercase">구글 계정 연동 및 클라우드 백업</h3>
          </div>

          {!user ? (
            <div>
              <p className="text-xs text-slate-500 font-medium leading-relaxed mb-4">
                💡 로그인을 하시면 클라우드를 통해 운동 데이터가 저장됩니다!
              </p>
              <button 
                onClick={handleGoogleLogin} 
                className="w-full h-12 bg-white border border-slate-200 text-slate-700 rounded-xl font-bold text-xs flex items-center justify-center gap-2 shadow-sm hover:bg-slate-100 transition-colors"
              >
                <svg className="w-4 h-4" viewBox="0 0 24 24">
                  <path fill="#EA4335" d="M12.24 10.285V14.4h6.887c-.275 1.565-1.88 4.604-6.887 4.604-4.33 0-7.866-3.577-7.866-8s3.536-8 7.866-8c2.46 0 4.105 1.025 5.047 1.926l3.227-3.11C18.232 1.964 15.44 1 12.24 1 6.033 1 12.24s5.033 11.24 11.24 11.24c6.478 0 10.793-4.537 10.793-10.986 0-.74-.08-1.3-.176-1.714H12.24z"/>
                </svg>
                Google 계정으로 로그인
              </button>
            </div>
          ) : (
            <div className="space-y-4">
              <div className="flex items-center justify-between bg-white p-3 rounded-xl border border-slate-100">
                <div>
                  <span className="text-[10px] text-slate-400 font-bold block">로그인된 계정</span>
                  <span className="text-sm font-black text-slate-700">{user.email}</span>
                </div>
                <button 
                  onClick={handleLogout} 
                  className="text-[11px] bg-slate-200 text-slate-600 font-bold px-3 py-1.5 rounded-lg hover:bg-rose-100 hover:text-rose-600 transition-colors"
                >
                  로그아웃
                </button>
              </div>

              <div className="bg-indigo-50/50 p-3.5 rounded-xl border border-indigo-100 space-y-2">
                <p className="text-[11px] text-indigo-700 font-bold">
                  ☁️ 데이터를 클라우드와 수동 동기화할 수 있습니다.
                </p>
                <div className="grid grid-cols-2 gap-2">
                  <button 
                    onClick={backupToCloud} 
                    className="h-10 bg-indigo-600 text-white rounded-lg text-xs font-bold flex items-center justify-center gap-1 shadow-sm hover:bg-indigo-700 transition-colors"
                  >
                    <span className="material-icons-round text-sm">cloud_upload</span>
                    현재 기록 백업
                  </button>
                  <button 
                    onClick={fetchFromCloud} 
                    className="h-10 bg-white border border-indigo-200 text-indigo-600 rounded-lg text-xs font-bold flex items-center justify-center gap-1 hover:bg-indigo-50 transition-colors"
                  >
                    <span className="material-icons-round text-sm">cloud_download</span>
                    백업 불러오기
                  </button>
                </div>
                {syncMessage && (
                  <p className="text-[10px] text-center text-indigo-600 font-black animate-pulse mt-1">
                    {syncMessage}
                  </p>
                )}
              </div>
            </div>
          )}
        </div>
      </section>
    );
}